<template>
  <div style="height: 100%; overflow: auto">
    <h5>{{ tablet_id }}</h5>
    <p class="text-left" v-html="tablet_content"></p>
  </div>
</template>

<script>
  import axios from 'axios';
  
  export default {
    data () {
      return {
        tablet_content: ''
      }
    },

    props: ['tablet_id'],

    watch: {
      tablet_id: function (val) {
        this.tablet_content = '';
        axios.post("/db/text", {tablet_id: val})
          .then(response => {this.tablet_content = response.data.rows[0]['cun_agg_html']})
          .catch(e => {console.log(e)})
      }
    }
  }
</script>

<style>
.cun_sign {
  text-transform: lowercase;
  font-variant: small-caps;
}
.cun_det {
  vertical-align: super;
  font-size: smaller;
}
.cun_pc {
  vertical-align: super;
  font-size: smaller;
  font-style: italic;
}
.cun_r_con {
  vertical-align: super;
  font-size: smaller;
}
.cun_index {
  vertical-align: sub;
  font-size: smaller;
}
.cun_desc {
  font-style: italic;
  color: gray
}
</style>



// WEBPACK FOOTER //
// src/components/TextView.vue